import NavBar from "@/components/navigation/NavBar";
import { React, useState, useEffect, useRef } from "react";
import Footer from "@/components/navigation/Footer";
import CtaContact from "@/components/calltoaction/CtaContact";
import { CalendarDateRangeIcon } from "@heroicons/react/24/outline";
import { IconSquare } from "@tabler/icons-react";
import GoogleTestimonials from "@/components/Landingpage/GoogleRating";
import { useOutsideClick } from "@/hooks/use-outside-click";
import CtaBewertenPoll from "@/components/calltoaction/CtaPdfBewerten";
import ButtonPrime from "@/components/navigation/ButtonPrime";
import Proof from "@/components/proofs/Proof";
import BeratungsterminModal from "@/components/form/BeratungsterminModal";
import VorteileSectionBeratung from "@/components/design/VorteileSectionBeratung";
import FaqSection from "@/components/navigation/faq";

export default function BeratungsTerminPage() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const containerRef = useRef(null);

  useOutsideClick(containerRef, handleClose);

  const [activeLink, setActiveLink] = useState(null);
  const handleLinkClose = () => setActiveLink(null);
  const linkContainerRef = useRef(null);

  useOutsideClick(linkContainerRef, handleLinkClose);

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    // Cleanup function to ensure body scrolling is restored
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  return (
    <div className="bg-gray-50">
      <NavBar className=" bg-white/100" />

      <div className="max-w-[85rem] pt-20 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="md:grid flex flex-col-reverse md:grid-cols-2 gap-4 md:gap-8 xl:gap-20 md:items-center">
          <div className=" md:pt-20 flex flex-col justify-center">
            <h1 className="block text-center md:text-left font-serif text-3xl pt-10 md:pt-0 font-bold text-dark-100 sm:text-4xl lg:text-5xl lg:leading-tight">
              Persönliche Beratung für Ihre Situation
            </h1>
            <p className="mt-5 text-center md:text-left text-lg md:text-xl text-gray-600">
              Erbe, Trennung oder Neuanfang? Wir hören zu und beraten Sie
              unverbindlich.
            </p>
            <BeratungsterminModal
              trigger={
                <ButtonPrime
                  className="mt-10 w-full"
                  text="Beratungstermin vereinbaren"
                  icon={
                    <CalendarDateRangeIcon className=" stroke-gray-100 size-7" />
                  }
                />
              }
            />
            <div className="md:w-[33rem] mt-10 space-y-5">
              <Proof />
            </div>
            <div className="mt-6 lg:mt-10 grid grid-cols-2 gap-x-5"></div>
          </div>
          <div className="relative ms-4">
            <img
              className="w-full  rounded-md"
              src="/Fotos/beratungstermin-hero-jakobs.jpg"
              alt="Leon Jakobs steht mit verschränkten Armen an einer Wand"
            />
            <div className="absolute inset-0 -z-[1] bg-gradient-to-tr from-gray-200 via-white/0 to-white/0 size-full rounded-md mt-4 -mb-4 me-4 -ms-4 lg:mt-6 lg:-mb-6 lg:me-6 lg:-ms-6"></div>
          </div>
        </div>
      </div>
      <div>
        <VorteileSectionBeratung />
      </div>

      <div>
        <div>
          <div className="flex flex-col gap-20 md:flex-row max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
            <div className="">
              <img
                className="md:h-full rounded-lg object-cover  md:max-w-[35rem]"
                src="/Fotos/beratungstermin-beratung-jakobs.jpg"
                alt=""
              />
            </div>
            <div className="md:w-1/2 md:mt-10 mt-0">
              <h2 className="text-xl md:text-4xl md:leading-normal font-serif  font-semibold text-prime-950 pb-2">
                Warum ist eine Beratung so wichtig?
              </h2>
              <div className="mt-4">
                <div className="">
                  <div className="text-large md:text-xl pb-2 flex items-center gap-5 ">
                    <IconSquare className="size-2 md:size-2 rotate-45 shrink-0 stroke-prime-600 fill-prime-600 inline" />
                    <h3 className="text-xl font-medium text-dark-200">
                      Marktlage verstehen
                    </h3>{" "}
                  </div>
                  <p className="text-large md:text-xl ">
                    Wie entwickelt sich der Immobilienmarkt? Wir geben Ihnen
                    eine realistische Einschätzung und wertvolle Einblicke.
                  </p>
                </div>
              </div>
              <div className="mt-4">
                <div className="">
                  <div className="text-large md:text-xl pb-2 flex items-center gap-5 ">
                    <IconSquare className="size-2 md:size-2 rotate-45 shrink-0 stroke-prime-600 fill-prime-600 inline" />
                    <h3 className="text-xl font-medium text-dark-200">
                      {" "}
                      Verkaufen oder halten?
                    </h3>{" "}
                  </div>
                  <p className="text-large md:text-xl ">
                    Nicht immer ist der Verkauf die beste Option. Gemeinsam
                    prüfen wir Ihre Möglichkeiten.
                  </p>
                </div>
              </div>
              <div className="mt-4">
                <div className="">
                  <div className="text-large md:text-xl pb-2 flex items-center gap-5 ">
                    <IconSquare className="size-2 md:size-2 rotate-45 shrink-0 stroke-prime-600 fill-prime-600 inline" />
                    <h3 className="text-xl font-medium text-dark-200">
                      {" "}
                      Der richtige Preis
                    </h3>{" "}
                  </div>
                  <p className="text-large md:text-xl ">
                    Eine marktgerechte Bewertung vermeidet Fehleinschätzungen
                    und sorgt für einen erfolgreichen Verkauf.
                  </p>
                </div>
              </div>
              <BeratungsterminModal
                trigger={
                  <button className="bg-prime-100 hover:bg-prime-200 transition-all text-prime-950 mt-8 p-4 rounded-lg text-lg font-medium">
                    Jetzt Käufer finden
                  </button>
                }
              />
            </div>
          </div>
        </div>
      </div>
      <div>{/* <Stats /> */}</div>
      <div className="px-4 py-24 md:py-40 lg:px-6 max-w-[85rem] mx-auto">
        <CtaBewertenPoll />
      </div>
      <div>
        <GoogleTestimonials />
      </div>

      <div className="py-20 bg-gray-50">
        <CtaContact />
      </div>
      <div>
        <FaqSection faqArt="verkaufen" />
      </div>
      <Footer />
    </div>
  );
}
